"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricingErrors = void 0;
var interfaces_1 = require("../common/interfaces");
exports.PricingErrors = {
    UNKNOWN_FAILURE: {
        code: 'PRICING-000',
        message: 'Unknown response',
        type: interfaces_1.ErrorType.SERVER,
    },
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/pricingApi/constants.js
// module id = 3396
// module chunks = 11